import { render, staticRenderFns } from "./ed-chip-group.vue?vue&type=template&id=8f5c180a&scoped=true&"
import script from "./ed-chip-group.ts?vue&type=script&lang=js&"
export * from "./ed-chip-group.ts?vue&type=script&lang=js&"
import style0 from "./ed-chip-group.scss?vue&type=style&index=0&id=8f5c180a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f5c180a",
  null
  
)

export default component.exports